import { WithPopover } from '@american-autonomy/ag-ui';

import MapDropdown from 'components/MapDropdown';
import MapDropdownItem from 'components/MapDropdown/components/MapDropdownItem';

import PopoverTrigger from './components/PopoverTrigger';
import { DROPDOWN_DIRECTION, TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const MapControlPopover = <T,>({
    displayIcon,
    displayText,
    onChange,
    options,
    testId = TEST_ID,
    value
}: Props<T>) => {
    const selectedOption = options.find(option => option.value === value);
    const textToDisplay = displayText || selectedOption?.label || '';

    const handleOptionClick = (optionValue: T) => {
        if (optionValue !== value) {
            onChange(optionValue);
        }
    };

    return (
        <WithPopover
            trigger={
                <PopoverTrigger
                    displayIcon={displayIcon}
                    displayText={textToDisplay}
                    selectedLabel={selectedOption?.label}
                />
            }
            className={styles.withPopover}
            direction={DROPDOWN_DIRECTION}
            testId={testId}>
            <MapDropdown className={styles.mapDropdown}>
                {options.map(option => (
                    <MapDropdownItem
                        isSelected={option.value === value}
                        key={option.value}
                        onClick={() => handleOptionClick(option.value as T)}
                        text={option.label}
                    />
                ))}
            </MapDropdown>
        </WithPopover>
    );
};

export default MapControlPopover;
